import Env from '../base/env'
import { TweenLite, Power3 } from 'gsap'
import ScrollTo from 'gsap/ScrollToPlugin'

export default class Accordion
{
    constructor(view,anchorMode = false,klassOverride='')
    {
        this.view = view
        this.$trigger = this.view.querySelector('.jsTrigger')
        this.$text = this.$trigger.querySelector('.text')
        this.$content = this.view.querySelector('.jsContent')
        this.textOpen = trans.learnMore
        this.textClose = trans.learnMoreClose
        this.klassName = 'is--active'
        if(klassOverride.length) {
            this.klassName = klassOverride
        }
        this.anchorMode = anchorMode
        this.heightOpen = 0
    }

    close()
    {
        this.$trigger.classList.remove('is--active')
        if(this.$text != null) {
            this.$text.innerHTML = this.textOpen
        }

        TweenLite.to(this.$content , .4 , { height : 0 , ease : Power3.easeOut , onStart:()=> {
                this.view.classList.remove(this.klassName)
            }
        })
    }

    events()
    {
        this.$trigger.addEventListener('click',()=>{
            const status = this.view.classList.contains(this.klassName)
            if(status) {
                this.close()
            } else {

                this.open()
            }

        })
    }

    open()
    {
        this.$trigger.classList.add('is--active')
        if(this.$text != null) {
            this.$text.innerHTML = this.textClose
        }
        TweenLite.to(this.$content , .7 , { height : this.heightOpen , ease : Power3.easeInOut , onStart:()=> {
                this.view.classList.add(this.klassName)
            }
        })
        if(this.anchorMode === true) {
            TweenLite.to(Env.$window , .6 ,  { scrollTo : { y : this.view.getBoundingClientRect().y  }, ease : Cubic.easeOut })
        }
    }

    resize()
    {
        this.$content.removeAttribute('style')
        this.setSize()
        this.$content.style.height = '0px'
    }

    setSize()
    {
        this.heightOpen = this.$content.getBoundingClientRect().height
    }

    setup()
    {
        this.setSize()
        this.$content.style.height = '0px'
        this.events()
    }
}